import React from 'react';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import List from '#app/View/ClientService/OrderClientLitigeList/components/List';
import Search from '#app/View/ClientService/OrderClientLitigeList/components/Search';
import OrderClientLitigeEntryPoints from '#app/entrypoints/orderClientLitige';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { CarrierCode } from '#app/typings/carrier';
import { Channel } from '#app/typings/channel';
import { OrderClientState } from '#app/typings/orderClient';
import { DisputeList, DisputeState, DisputeType } from '#app/typings/orderClientLitige';

export type Filters = {
  states?: DisputeState[];
  types?: DisputeType[];
  channels?: Channel[];
  orderClientStates?: OrderClientState[];
  carriers?: CarrierCode[];
  number?: string;
  email?: string;
  name?: string;
};

const OrderClientLitigeList: React.FC = () => {
  const { setFilters, filters, ...props } = useCollectionPaginated<DisputeList, Filters>(
    OrderClientLitigeEntryPoints.getCollection,
    {
      filters: { states: [DisputeState.PENDING_PROCESSING] },
      sorting: { sortName: 'createdAt', sortDirection: 'desc' },
    },
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des commandes client en litige', context: 'Service client' }}>
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewComponent>
  );
};

export default OrderClientLitigeList;
